// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"465":"d7a19af1","879":"93767728"}[chunkId] + ".chunk.js";
};